import { render, staticRenderFns } from "./midB.vue?vue&type=template&id=3893db05&"
import script from "./midB.vue?vue&type=script&lang=js&"
export * from "./midB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports